<h2 mat-dialog-title>DPP Details</h2>

<mat-dialog-content>

  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >

      <div class="topNavbar">
        <div>
          <button mat-button class="m-1 secondary-gray-button-2" (click)="openDetailedView();">
            <mat-icon>open_in_new</mat-icon>{{'open' | translate}}
          </button>
          <button mat-button class="m-1 secondary-gray-button-2" (click)="QRoptions()">
            <mat-icon> qr_code_2_add</mat-icon> Sample QR
          </button>
        </div>
      </div>
      <div class="my-4"> <mat-icon class="custom-card-icon material-symbols-outlined">info</mat-icon>{{'tridys.tridy_info' | translate}} </div>
      <mat-card class="mb-2">
        <mat-card-content class="my-2">
          @if (titleValue && titleKey) {
            <h2 class="title-key"><strong>{{titleValue}}</strong></h2>
          }
          @if (subtitleValues && subtitleValues.length>0) {
            <div>
              @for (subtitle of subtitleValues; track subtitle) {
                <div class="subtitle-key my-1 font-weight-bold">
                  @if (subtitle?.contentType === 'public.image' && subtitleKeys) {
                    <span>{{subtitle.fileName}}</span>
                  }
                  @if (subtitle?.contentType !== 'public.image' && subtitleKeys) {
                    <span>{{subtitle}}</span>
                  }
                </div>
              }
              @if (subtitleKeys) {
                <mat-divider class="my-3"></mat-divider>
              }
            </div>
          }
          <!-- if content type has this defined, then those should be shown and set according to payload -->
          <span class="font-weight-bold">ID: </span> <span style="opacity:0.65;padding-right: 5px;">{{data.idToShow}}</span><mat-icon matTooltip="{{'copyToClipboard' | translate}}" [cdkCopyToClipboard]="idToShow" class="copy_id">content_copy</mat-icon><br>
          @if (tridyData && tridyData.creationDate) {
            <span class="font-weight-bold">{{'creation_date' | translate}}: </span>
            } @if (tridyData && tridyData.creationDate) {
            <span  style="opacity:0.65;">{{tridyData.creationDate.toDate() | date: 'dd.MM.yyyy, HH:mm'}}</span>
          }
        </mat-card-content>
      </mat-card>


      @if (finishedTasks?.length!=0) {
        <div class="my-2">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title style="color:#595c5f;">
                <mat-icon style="margin-right:10px;">task</mat-icon>{{'tridys.finished' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-card class="mb-2">
              <mat-card-content class="my-2">
                @for (ftask of finishedTasks; track ftask) {
                  <div class="item-content my-1" (click)="openFinishedTaskInNewTab(ftask)">
                    <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                      <div class="d-flex flex-column flex-nowrap">
                        <span style="color:var(--warmOrange);">{{ftask.title}}</span>
                        <div>
                          <span class="text-muted">{{ftask.creationDate.toDate() | date:'dd.MM.yyyy, HH:mm' }}</span>
                          @if (ftask.timeStamp) {
                            <span class="text-muted">  - {{ftask.timeStamp.toDate() | date:'dd.MM.yyyy, HH:mm' }}</span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </mat-card-content>
            </mat-card>
          </mat-expansion-panel>
        </div>
      }

      <!-- INCOMING -->
      @if (incoming && incoming.length!=0) {
        <div class="my-2">
          <app-tridy-icoming-outgoing-data-card  type='incoming' [data]="incoming" [allTridysList]="allTridysList" [allContentTypesList]="allContentTypesList" />
          <!-- <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title style="color:#595c5f;">
              <mat-icon style="margin-right: 10px;">input</mat-icon>{{'workTask.incoming_tridys' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card class="mb-2">
            <mat-card-content class="my-2">
              <div *ngFor="let incom of incoming; let index" class="item-content incoming my-1" (click)="openDetailedView(incom.tridyId)">
                <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                  <div class="d-flex flex-column flex-nowrap">
                    <div *ngIf="incom.payload">
                      <div *ngIf="getContentTypeFieldById(incom.contentTypeId, 'titleKey')" class="title-key-2">
                        {{getTitleKeyOfTridy(getTRIDYIdData(incom.tridyId, 'payload'), getContentTypeFieldById(incom.contentTypeId, 'titleKey'))}}
                      </div>
                      <div *ngIf="getContentTypeFieldById(incom.contentTypeId, 'subtitleKeys')">
                        <div *ngFor="let subtitle of getSubtitleKeyOfTridy(getTRIDYIdData(incom.tridyId, 'payload'), getContentTypeFieldById(incom.contentTypeId, 'subtitleKeys'))">
                          <div class="subtitle-key-2" *ngIf="subtitle?.contentType === 'public.image'">{{subtitle.fileName}}</div>
                          <div class="subtitle-key-2" *ngIf="subtitle?.contentType !== 'public.image'">{{subtitle}}</div>
                        </div>
                      </div>
                      <span *ngIf="!getContentTypeFieldById(incom.contentTypeId, 'titleKey') && !getContentTypeFieldById(incom.contentTypeId, 'subtitleKeys')" class="title-key-2">
                        {{getContentTypeFieldById(incom.contentTypeId, 'displayName')}}
                      </span>
                    </div>
                    <div *ngIf="!incom.payload">
                      <span class="title-key-2">
                        {{getContentTypeFieldById(incom.contentTypeId, 'displayName')}}
                      </span>
                    </div>
                    <div class="mt-1">ID: {{incom.tridyId}}</div>
                    <div class="d-flex flex-column text-muted">
                      <span *ngIf="getTRIDYIdData(incom.tridyId, 'creationDate')">
                        {{'creation_date' | translate}}: {{getTRIDYIdData(incom.tridyId, 'creationDate').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                      </span>
                      <span *ngIf="getTRIDYIdData(incom.tridyId, 'timeStamp')">
                        {{'last_update' | translate}}: {{getTRIDYIdData(incom.tridyId, 'timeStamp').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-expansion-panel> -->
      </div>
    }

    <!-- OUTGOING -->
    @if (outgoing && outgoing.length!=0) {
      <div class="my-2">
        <app-tridy-icoming-outgoing-data-card  type='outgoing' [data]="outgoing" [allTridysList]="allTridysList" [allContentTypesList]="allContentTypesList" />
        <!-- <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title style="color:#595c5f;">
            <mat-icon style="margin-right: 10px;">output</mat-icon>{{'workTask.outgoing_tridys' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card class="mb-2">
          <mat-card-content class="my-2">
            <div *ngFor="let out of outgoing; let index" class="item-content outgoing my-1" (click)="openDetailedView(out.tridyId)">
              <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                <div class="d-flex flex-column flex-nowrap">
                  <div *ngIf="out.payload">
                    <div *ngIf="getContentTypeFieldById(out.contentTypeId, 'titleKey')" class="title-key-2">
                      {{getTitleKeyOfTridy(getTRIDYIdData(out.tridyId, 'payload'), getContentTypeFieldById(out.contentTypeId, 'titleKey'))}}
                    </div>
                    <div *ngIf="getContentTypeFieldById(out.contentTypeId, 'subtitleKeys')">
                      <div *ngFor="let subtitle of getSubtitleKeyOfTridy(getTRIDYIdData(out.tridyId, 'payload'), getContentTypeFieldById(out.contentTypeId, 'subtitleKeys'))">
                        <div class="subtitle-key-2" *ngIf="subtitle?.contentType === 'public.image'">{{subtitle.fileName}}</div>
                        <div class="subtitle-key-2" *ngIf="subtitle?.contentType !== 'public.image'">{{subtitle}}</div>
                      </div>
                    </div>
                    <span *ngIf="!getContentTypeFieldById(out.contentTypeId, 'titleKey') && !getContentTypeFieldById(out.contentTypeId, 'subtitleKeys')" class="title-key-2">
                      {{getContentTypeFieldById(out.contentTypeId, 'displayName')}}
                    </span>
                  </div>
                  <div *ngIf="!out.payload">
                    <span class="title-key-2">
                      {{getContentTypeFieldById(out.contentTypeId, 'displayName')}}
                    </span>
                  </div>
                  <div class="mt-1">ID: {{out.tridyId}}</div>
                  <div class="d-flex flex-column text-muted">
                    <span *ngIf="getTRIDYIdData(out.tridyId, 'creationDate')">
                      ´                                                {{'creation_date' | translate}}: {{getTRIDYIdData(out.tridyId, 'creationDate').toDate() ? (getTRIDYIdData(out.tridyId, 'creationDate').toDate() | date:'dd.MM.yyyy, HH:mm') : '' }}
                    </span>
                    <span *ngIf="getTRIDYIdData(out.tridyId, 'timeStamp')">
                      {{'last_update' | translate}}: {{getTRIDYIdData(out.tridyId, 'timeStamp').toDate() ? (getTRIDYIdData(out.tridyId, 'timeStamp').toDate() | date:'dd.MM.yyyy, HH:mm') : '' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-expansion-panel> -->
    </div>
  }

  <!-- DISPLAY TEMPLATE -->
  @if (contentTypeData?.displaySections) {
    <div>
      <div class="my-4 mb-2 section-title">
        <mat-icon class="custom-card-icon material-symbols-outlined">description</mat-icon>{{'tridys.payloadData' | translate}}
      </div>
      @for (group of contentTypeData.displaySections; track group) {
        <div>
          <mat-card class="mb-4">
            @if (group.title) {
              <mat-card-header>
                <strong>{{group.title}}</strong>
              </mat-card-header>
            }
            <mat-card-content class="p-3">
              @for (field of group.fields; track field; let last = $last) {
                <div>
                  <div class="d-flex justify-content-between">
                    <div class="py-2 px-2 ps-0 mx-1 key-styles"><span class="font-weight-bold">{{field.title}}</span></div>
                    <div class="py-2 px-2 pe-0 mx-1 value-styles">
                      <span>{{getPayloadDataByFieldKey(field.key)}}</span>
                    </div>
                  </div>
                  @if (!last) {
                    <mat-divider></mat-divider>
                  }
                </div>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  }

  <!-- show all button -->
  <div class="w-100 d-flex justify-content-center">
    @if (contentTypeData?.displaySections) {
      <button mat-button
        [class.d-none]="contentTypeData?.displaySections && showAll"
        (click)="showAllPayload()" class="mt-1 mb-4 secondary-gray-button">
        {{'showAll' | translate}}
      </button>
    }
  </div>

  <!-- all payload -->
  <div #payloadCard [class.d-none]="contentTypeData?.displaySections && !showAll">
    <div class="my-4 section-title">
      <mat-icon class="custom-card-icon material-symbols-outlined">description</mat-icon>{{'tridys.allPayloadData' | translate}}
    </div>

    <mat-card class="mb-4">
      <mat-card-content class="p-3">
        @if (allpayload.length==0) {
          <div class="p-3">
            <span class="text-muted">{{'tridys.no_payload_data' | translate}}</span>
          </div>
        }
        @for (payload of allpayload; track payload; let last = $last; let index = $index) {
          <div>
            @if (!isObject(payload[1])) {
              <div class="d-flex justify-content-between">
                <!-- <div class="input-group mt-1 mb-1 w-100" *ngIf="payload[0]!='name' && payload[0]!='description' && payload[0]!='tagline' && payload[0]!='array' && payload[0]!='map'"> -->
                <div class="py-2 px-4 key-styles"><span class="font-weight-bold">{{payload[0]}}</span></div>
                <div class="py-2 px-4 value-styles">
                  @if (payload[1] && !payload[1].nanoseconds && !payload[1].seconds && !matchingDate(payload[1])) {
                    <span>{{payload[1]}}</span>
                  }
                  @if (payload[1] && !payload[1].nanoseconds && !payload[1].seconds && matchingDate(payload[1])) {
                    <span>{{payload[1] | date: 'dd.MM.yyyy, HH:mm'}}</span>
                  }
                  @if (payload[1] && (payload[1].nanoseconds || payload[1].seconds)) {
                    <span>{{payload[1].toDate() | date: 'dd.MM.yyyy, HH:mm' }}</span>
                  }
                </div>
              </div>
            }
            @if (isObject(payload[1]) && payload[1]?.contentType) {
              <div class="d-flex justify-content-between">
                <div class="py-2 px-4 key-styles">
                  <span class="font-weight-bold">{{payload[0]}}</span> <span class="material-symbols-outlined text-muted" style="vertical-align: middle;font-size: 20px;">attach_file</span>
                </div>
                <div class="py-2 px-4 value-styles">
                  @if (!fileName[payload[0]] && mediaData && media) {
                    <div>
                      @if (payload[1]?.fileName) {
                        <a href="{{urlData[payload[0]]}}" class="pdf-title" target="_blank">
                          <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>{{payload[1].fileName}}
                        </a>
                      }
                    </div>
                  }
                  @if (fileName[payload[0]] && mediaData && media && media[payload[0]]) {
                    <div>
                      @if (urlData[payload[0]]) {
                        <a href="{{urlData[payload[0]]}}" target="_blank" style="cursor:zoom-in;">
                          <img src="{{urlData[payload[0]]}}" style="height:150px;width:auto;">
                        </a>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            @if (isObject(payload[1]) && !payload[1]?.contentType) {
              <div class="d-flex justify-content-between">
                <div class="py-2 px-4 key-styles"><span class="font-weight-bold">{{payload[0]}}</span></div>
                @if (!payload[1]) {
                  <span class="py-2 px-4 value-styles"> - </span>
                }
                @if (payload[1] && !payload[1].nanoseconds && !payload[1].seconds) {
                  <span class="py-2 px-4 value-styles">
                    <div [app-tridys-item-tree-data]="[payload[0], payload[1], index]"> </div>
                  </span>
                }
                @if (payload[1] && (payload[1].nanoseconds || payload[1].seconds)) {
                  <span class="py-2 px-4 value-styles"> {{payload[1].toDate() | date: 'dd.MM.yyyy, HH:mm' }} </span>
                }
              </div>
            }
            @if (!last) {
              <mat-divider></mat-divider>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>

    <div class="mb-4">
      @if (tridyArray) {
        <mat-accordion class="w-100 mt-4">
          <mat-expansion-panel (opened)="panelOpenState=true" (closed)="panelOpenState=false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'tridys.array' | translate}}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            @for (array of tridyArray; track array) {
              <p>{{array}}</p>
            }
          </mat-expansion-panel>
        </mat-accordion>
      }
      @if (tridyMap) {
        <mat-accordion class="w-100 mt-2">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'tridys.map' | translate}}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            @for (map of tridyMap | keyvalue; track map) {
              <p> {{map.key}} : {{map.value}}</p>
            }
          </mat-expansion-panel>
        </mat-accordion>
      }
    </div>
  </div>

</section>
</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="dialogCancel();"> {{'Close' | translate}} </button>
</mat-dialog-actions>
